<template>
  <div class="my-table queuePage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('queueManangement.txt1')}}</span>
        <span>{{$t('queueManangement.txt2')}} / {{$t('queueManangement.txt3')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn" @click="goAddQueue">{{$t('queueManangement.txt4')}}</div>
      </div>
    </div>
    <el-row :gutter="20" class="cardContent">
      <el-col :span="8" class="cardBox" v-for="(item,index) in dataList" :key="index">
        <el-tooltip placement="right-end" effect="light" popper-class="atooltip" visible-arrow="false">
          <div slot="content" class="modelBox">
            <div class="header">{{item.queueName?item.queueName:'--'}}</div>
            <el-form ref="item" label-position="right" :model="item" label-width="80px">
              <el-form-item :label="$t('queueManangement.txt8')">
                <span v-for="(gitem,gindex) in item.calculations" :key="gindex">
                  <span>{{gitem.calculationName?gitem.calculationName:'--'}}</span>
                  <span v-if="gindex < item.calculations.length-1">，</span>
                </span>
              </el-form-item>
              <el-form-item :label="$t('queueManangement.txt6')">
                <span v-for="(gitem,gindex) in item.projects" :key="gindex">
                  <span>{{gitem.projectName?gitem.projectName:'--'}}</span>
                  <span v-if="gindex < item.projects.length-1">，</span>
                </span>
              </el-form-item>
              <el-form-item :label="$t('queueManangement.txt7')">
                <span v-for="(gitem,gindex) in item.userInfos" :key="gindex">
                  <span>{{gitem.userName?gitem.userName:'--'}}</span>
                  <span v-if="gindex < item.userInfos.length-1">，</span>
                </span>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="header">
              <span>{{item.queueName?item.queueName:'--'}}</span>
              <div class="fr">
                <img @click="handleEdit(item)" src="@/assets/picture/icon/edit_icon.png"/>
                <img @click="handleDelete(item)" src="@/assets/picture/icon/delete_S_icon.png"/>
              </div>
            </div>
            <div class="contentBox">
              <div class="picBox">
                <img class="desktopPic" @click="handleEdit(item)" src="@/assets/picture/icon/queue_img.png"/>
              </div>
              <div class="contentBox">
                <p>
                  <span class="labelTxt fl">{{$t('queueManangement.txt8')}}</span>
                  <span class="txt fl" v-for="(gitem,gindex) in item.calculations" :key="gindex">
                    <span>{{gitem.calculationName}}</span>
                    <span v-if="gindex < item.calculations.length-1">,</span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </el-tooltip>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { formatDate } from "@/plugins/date.js";
  import qs from 'qs';
  export default {
    data() {
      const generateData = _ => {
        const userList = [];
        for (let i = 1; i <= userList.length; i++) {
          userList.push({
            key: userList[i].value,
            label: userList[i].label,
          });
        }
        return userList;
      };
      return {
        fromData:{},//分享参数
        distributionParams:{
          id:"",
          desktopName:"",
          lanIp:"",
          wanIp:"",
          desktopPort:"",
          desktopUrl:"",
          desktopDescribe:"",
          userInfos:[],
          online:true,
          state: 1
        },
        //用于获取数据列表
        queryInfo: {
          cmptName:'',
          endCreateTm:'',
          pageNum:0,
          pageSize: 10,
          productTmplCmptId:'',
          projName:'',
          spvTm:'',
          startCreateTm:'',
          submitterName:'',
          witnCde:'',
          witnType:'',
        },
        dataList: [],
        total: 0,
      };
    },
    created() {
      this.loadData();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // 队列列表
      async loadData() {
        const {data: res} = await this.$http.post("/calculation/queue/list");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dataList = res.result;
      },
      // 添加队列
      goAddQueue(){
        this.$router.push({path: "/addQueue"});
      },
      // 新建节点
      addProject(){
        this.dotParams = {
          id:"",
          desktopName:"",
          lanIp:"",
          wanIp:"",
          desktopPort:"",
          desktopUrl:"",
          desktopDescribe:"",
          userInfos:[],
          online:true,
          state: 1
        };
        this.visibleTitle = this.$t('queueManangement.txt9');
        this.dialogFormAddVisible = true;
      },
      // 编辑节点
      handleEdit(row){
        this.$router.push({path: '/editQueue', query: {id: row.id}});
    },
      // 删除
      handleDelete(item){
        let id = item.id;
        this.$confirm('<p class="color666 fz14">'+this.$t('queueManangement.txt10')+'</p><p class="color999 fz14">'+this.$t('queueManangement.txt11')+'</p>',this.$t('menuManagement.txt11'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('queueManangement.txt12'),
          cancelButtonText: this.$t('queueManangement.txt13'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteQueue(id); 
        }).catch(() => {
         this.$message({
          type: 'info',
          message: this.$t('queueManangement.txt14')
        });      
       });
      },
      async deleteQueue(id) {
        const {data: res} = await this.$http.post("/calculation/queue/delete?id="+id);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('queueManangement.txt15')
        });
        this.loadData();
      },
      // 跳转在线节点
      goOnlinePage(){
        this.$router.push({path: "/onlineUser"});
      },
      // 页面切换
      handleCurrentChange(pageNum) {
        this.queryInfo.pageNum = pageNum;
        this.loadData();
      },
      handleSizeChange(pageSize){
        this.queryInfo.pageSize = pageSize;
        this.loadData();
      },
    },
  };
</script>

<style lang="less" scoped>
  /deep/ .el-select{
    width: 100%;
  }
  .input-with-select{
    margin-bottom: 20px;
    /deep/ .el-input-group__append, .el-input-group__prepend{
      padding:0;
    }
  }
  .checkBox{
    /deep/ .el-checkbox__label{
      font-size: 14px;
      font-weight: 400;
      color: #1B3B7C;
    }
  }
  .userBox{
    .el-checkbox-group{
      div{
        margin-bottom: 20px;
      }
    }
  }
  .cpuBox{
    display: flex;
    margin-bottom: 10px;
    .labelTxt{
      font-size: 12px;
      font-weight: 400;
      color: #1B3B7C;
      line-height: 37px;
    }
    /deep/ .el-slider{
      width: 60%;
      display: block;
      margin:0 10px;
    }
    .txt{
      /deep/ .el-input-number__decrease,/deep/ .el-input-number__increase{
        display: none;
      }
      /deep/ .el-input__inner{
        padding:0;
      }
      /deep/ .el-input-number--mini{
        width: 40px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color:#1B3B7C;
      }
    }
  }
  .queuePage{
    .w32{
     /deep/ .el-input,/deep/ .el-input__inner{
       width: 100% !important;
     }
   }
   .inputBox{
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    text-align: left;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    line-height: 32px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
  }
  .searchBox{
    /*width: 33.6rem !important;*/
    /*height: 3.2rem;*/
    .btnC{
      padding:0.6rem 2.6rem;
    }
  }
  /deep/ .el-transfer__button:first-of-type{
    display: none;
  }
  /deep/ .el-button--primary{
    width: auto;
    height: auto;
    padding:0;
    background: none;
  }
  /deep/ .el-button--primary.is-disabled{
    background: none;
    border: none;
  }
  /deep/ .el-button+.el-button{
    margin-left: 0 !important;
  }
  /deep/ .el-transfer__buttons{
    padding:0;
  }
  .tips{      
    font-size: 1.4rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #98B9FF;
    margin-top: -10px;
  }
  /deep/ .el-dialog{
    /deep/ .el-input,/deep/ .el-input__inner{
      width: 100% !important;
    }
    /deep/ .el-select{
      width: 100%;
    }
    /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
      border-radius: 8px; 
    }
  }
  .cardContent{
    width: 100%;
    margin-top: 1.6rem;
    margin-left: 0 !important;
    .cardBox:nth-of-type(3n+3){
      margin-right: 0;
    }
    .cardBox{
      padding:3rem !important; 
      background: #fff;
      border-radius: 3rem;
      margin-bottom: 3rem;
      margin-right: 3rem;
      width: 31.5%;
      width: 31.5%;
      .header{
        border-bottom: 1px solid #CBCBCB;
        padding-bottom: 2rem;
        span{          
          ont-size: 1.4rem;
          font-weight: 400;
          color: #222;
          cursor: pointer;
        }
        img{
          width: 1.4rem;
          height: 1.8rem;
          margin-right: 2rem;
          cursor: pointer;
        }
        img:last-of-type{
          margin-right: 0;
        }
      }
      .contentBox{
        padding-top:1.6rem;
        .desktopPic{
          width: 10.2rem;
          height: 10.2rem;
          display: block;
          margin: 0 auto;
        }
        p:first-of-type{
          margin-bottom:1.5rem;
        };
        p:nth-of-type(2){
          margin-bottom:1.5rem;
        };
        p{            
          font-size: 1.2rem;
          font-weight: 400;
          color: #999999;
          overflow: hidden;
          span{
            color: #666;
          }
          .dot{
            width: 1.2rem;
            height: 1.2rem;
            background: #1AA600;
            border-radius: 50%; 
            margin-right: 1.2rem;
            display: block;
            float: left;
            margin-top: 5px;
          }
          .greenDot{
            background: #D80000;
          }
        }
        .w19{
          width: 19%;
        }
        .labelTxt{            
          font-size: 1.4rem;
          margin-right: 1.4rem;
          font-weight: 400;
          color: #AEB0B9;
        }
        .txt{            
          font-size: 1.4rem;
          font-weight: 400;
          color: #222222;
          line-height: 2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .searchUserBox{
    width: 33.6rem !important;
    /deep/ .el-input-group__append{
      background: #fff !important;
      padding:0;
      border-left: none;
    }
  }    
}
</style>
